// extracted by mini-css-extract-plugin
export default {"propanePopupPage":"styles_propanePopupPage__Li+qW","loadingPage":"styles_loadingPage__VYr7v","popupBlock":"styles_popupBlock__7czeQ","noDataMessage":"styles_noDataMessage__hZwYe"};